import { render, staticRenderFns } from "./AdditionalHeaders.vue?vue&type=template&id=68840096&scoped=true&"
import script from "./AdditionalHeaders.vue?vue&type=script&lang=ts&"
export * from "./AdditionalHeaders.vue?vue&type=script&lang=ts&"
import style0 from "./AdditionalHeaders.vue?vue&type=style&index=0&id=68840096&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68840096",
  null
  
)

export default component.exports